import React from 'react'
import PropTypes from 'prop-types'
import {compose, pure} from 'recompose'
import classnames from 'classnames'
import {noop} from 'lodash'

import './Overlay.scss'

interface OverlayProps {
  onClick?: () => void,
  onDoubleClick?: () => void,
  isVisible?: boolean
}
export const Overlay: React.FC<OverlayProps> = ({onClick = noop, onDoubleClick = noop, isVisible}) => (
  <div styleName="overlay" onClick={onClick} onDoubleClick={onDoubleClick}>
    <div styleName={classnames('button', {'is-visible': isVisible})} />
  </div>
)
